export default __webpack_public_path__ + "static/media/Dreaming_TicketSquare_black_logo.707a95ee.ico";